import Typography from '@components/std-components/Typography'
import React, { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'
import InputEditorPopup from './InputEditorPopup'
import classNames from 'classnames'
import { CentricTypography } from '@core/component/CentricTypography'
import { makeStyles } from '@material-ui/core'

export interface InputEditorProps {
  value: string
  disabled: boolean
  header: string
  placeholder: string
  saveLabel?: string
  onChange: (value) => void
  className?: {
    typography?: string
  }
  isEnhancedViewEnabled?: boolean
}

const useStyles = makeStyles(theme => ({
  textContainer: {
    width: '100%',
    minHeight: '30px',
    cursor: 'pointer'
  },
  placeholder: {
    fontStyle: 'italic',
    fontWeight: 100,
    color: '#cccccc'
  },
  text: {
    padding: '0 10px'
  },
  clearText: {
    opacity: 1
  },
  enhancedPlaceholder: {
    fontWeight: 'normal',
    fontStyle: 'italic',
    cursor: 'pointer'
  },
  enhancedFontWeight: {
    fontWeight: 'normal'
  },
  disabled: {
    pointerEvents: 'none'
  }
}))

const InputEditor: FC<InputEditorProps> = ({
  value,
  disabled,
  header,
  placeholder,
  saveLabel,
  onChange,
  className: { typography = '' } = {},
  isEnhancedViewEnabled
}) => {
  const [isEditable, setIsEditable] = useState(false)
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <>
      <div
        className={classNames('flex column w-100 h-100', classes.text)}
        onClick={() => !disabled && setIsEditable(true)}
      >
        {isEnhancedViewEnabled ? (
          <CentricTypography
            variant={value ? 'overlineDarkGrey' : 'overlineLightGrey'}
            className={classNames(classes.textContainer, classes[typography], {
              [classes.enhancedFontWeight]: !classes[typography] && disabled,
              [classes.disabled]: disabled,
              [classes.enhancedPlaceholder]: !value
            })}
          >
            {value || placeholder}
          </CentricTypography>
        ) : (
          <Typography
            variant='caption2'
            disabled={disabled}
            classes={cn(
              classes.textContainer,
              !value && classes.placeholder,
              classes[typography]
            )}
          >
            {value || placeholder}
          </Typography>
        )}
      </div>
      {isEditable && (
        <InputEditorPopup
          value={value}
          onCancelClick={() => {
            setIsEditable(false)
          }}
          onClose={() => {
            setIsEditable(false)
          }}
          onSaveClick={updatedValue => {
            onChange(updatedValue)
            setIsEditable(false)
          }}
          header={header}
          placeholder={placeholder}
          saveLabel={saveLabel || t('common.label.save', 'Save')}
        />
      )}
    </>
  )
}

export default InputEditor
